<template>
  <component
    :is="type"
    class="block w-full text-sm focus:outline-hidden"
    :class="[
      `hover:bg-${color}-100 focus:bg-${color}-100`,
      disabled ? `cursor-default text-${color}-900/50 hover:text-${color}-900/50` : `text-${color}-900 hover:text-${color}-900`,
    ]"
    :aria-disabled="disabled || null"
    :disabled="disabled || null"
    :type="type === 'button' ? 'button' : false"
    @click="handleClick"
  >
    <span class="flex w-full items-center px-4 py-2 text-left">
      <svgicon v-if="icon" :name="icon" :fill="iconFill" class="mr-2" />
      <slot />
    </span>
  </component>
</template>

<script>
export default {
  inject: ["hide"],
  props: {
    icon: String,
    iconFill: Boolean,
    type: {
      type: String,
      default: "button",
    },

    disabled: Boolean,
    color: {
      type: String,
      default: "gray",
    },
  },

  emits: ["click"],

  methods: {
    handleClick() {
      this.$emit("click");
      this.hide();
    },
  },
};
</script>
